const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'enemies',
  tiles: {
    'l1-aoe-neonwiggler': 0,
    'l1-balanced-angrystar': 1,
    'l1-boss-hexbot': 2,
    'l1-damage-glowbug4': 3,
    'l1-sponge-flayerevo1': 4,
    'l2-aoe-creepeye': 5,
    'l2-armor-centislide': 6,
    'l2-balanced-greencyclopsworm': 7,
    'l2-boss-skitterbot': 8,
    'l2-damage-wildgrowth': 9,
    'l2-sponge-flayerevo2': 10,
    'l3-aoe-sickum': 11,
    'l3-armor-beeohm': 12,
    'l3-balanced-smokeeye': 13,
    'l3-boss-metalcrab': 14,
    'l3-damage-glowbug5': 15,
    'l3-sponge-flayerevo3': 16,
    'l4-aoe-smallgreenbeholder2': 17,
    'l4-armor-shellshy': 18,
    'l4-balanced-chaosorb': 19,
    'l4-boss-alienexplorer': 20,
    'l4-damage-glowbug6': 21,
    'l4-sponge-flayerevo4': 22,
    'l5-aoe-voidvirus': 23,
    'l5-armor-voidturtle': 24,
    'l5-balanced-voidspider': 25,
    'l5-boss-garbagecan': 26,
    'l5-damage-voidsnake': 27,
    'l5-sponge-voidsquirrel': 28,
    'l6-boss-octopot': 29,
    'npc-cyclops2': 30
  },
  uidata: {
    rects: [
      vec4(8/1024,8/2048,153/1024,148/2048),
      vec4(169/1024,8/2048,277/1024,148/2048),
      vec4(293/1024,8/2048,454/1024,148/2048),
      vec4(470/1024,8/2048,612/1024,148/2048),
      vec4(628/1024,8/2048,822/1024,148/2048),
      vec4(838/1024,8/2048,1016/1024,148/2048),
      vec4(8/1024,164/2048,233/1024,304/2048),
      vec4(249/1024,164/2048,345/1024,304/2048),
      vec4(361/1024,164/2048,528/1024,304/2048),
      vec4(544/1024,164/2048,742/1024,304/2048),
      vec4(758/1024,164/2048,868/1024,304/2048),
      vec4(8/1024,320/2048,189/1024,460/2048),
      vec4(205/1024,320/2048,339/1024,460/2048),
      vec4(355/1024,320/2048,526/1024,460/2048),
      vec4(542/1024,320/2048,702/1024,460/2048),
      vec4(718/1024,320/2048,885/1024,460/2048),
      vec4(8/1024,476/2048,126/1024,616/2048),
      vec4(142/1024,476/2048,308/1024,616/2048),
      vec4(324/1024,476/2048,454/1024,616/2048),
      vec4(470/1024,476/2048,610/1024,616/2048),
      vec4(626/1024,476/2048,762/1024,616/2048),
      vec4(778/1024,476/2048,927/1024,616/2048),
      vec4(8/1024,632/2048,135/1024,772/2048),
      vec4(151/1024,632/2048,286/1024,772/2048),
      vec4(302/1024,632/2048,544/1024,772/2048),
      vec4(560/1024,632/2048,710/1024,772/2048),
      vec4(726/1024,632/2048,861/1024,766/2048),
      vec4(8/1024,788/2048,214/1024,928/2048),
      vec4(230/1024,788/2048,392/1024,928/2048),
      vec4(8/1024,944/2048,651/1024,1364/2048),
      vec4(667/1024,944/2048,793/1024,1084/2048)
    ],
    aspect: [
      1.0357142857142858, 0.7714285714285715,
                    1.15, 1.0142857142857142,
      1.3857142857142857, 1.2714285714285714,
      1.6071428571428572, 0.6857142857142857,
      1.1928571428571428, 1.4142857142857144,
      0.7857142857142857,  1.292857142857143,
      0.9571428571428572, 1.2214285714285715,
      1.1428571428571428, 1.1928571428571428,
      0.8428571428571429, 1.1857142857142857,
      0.9285714285714286,                  1,
      0.9714285714285714, 1.0642857142857143,
      0.9071428571428571, 0.9642857142857143,
      1.7285714285714286, 1.0714285714285714,
       1.007462686567164, 1.4714285714285715,
      1.1571428571428573, 1.5309523809523808,
                     0.9
    ]
  },
  'FRAME_L1-AOE-NEONWIGGLER': 0,
  'FRAME_L1-BALANCED-ANGRYSTAR': 1,
  'FRAME_L1-BOSS-HEXBOT': 2,
  'FRAME_L1-DAMAGE-GLOWBUG4': 3,
  'FRAME_L1-SPONGE-FLAYEREVO1': 4,
  'FRAME_L2-AOE-CREEPEYE': 5,
  'FRAME_L2-ARMOR-CENTISLIDE': 6,
  'FRAME_L2-BALANCED-GREENCYCLOPSWORM': 7,
  'FRAME_L2-BOSS-SKITTERBOT': 8,
  'FRAME_L2-DAMAGE-WILDGROWTH': 9,
  'FRAME_L2-SPONGE-FLAYEREVO2': 10,
  'FRAME_L3-AOE-SICKUM': 11,
  'FRAME_L3-ARMOR-BEEOHM': 12,
  'FRAME_L3-BALANCED-SMOKEEYE': 13,
  'FRAME_L3-BOSS-METALCRAB': 14,
  'FRAME_L3-DAMAGE-GLOWBUG5': 15,
  'FRAME_L3-SPONGE-FLAYEREVO3': 16,
  'FRAME_L4-AOE-SMALLGREENBEHOLDER2': 17,
  'FRAME_L4-ARMOR-SHELLSHY': 18,
  'FRAME_L4-BALANCED-CHAOSORB': 19,
  'FRAME_L4-BOSS-ALIENEXPLORER': 20,
  'FRAME_L4-DAMAGE-GLOWBUG6': 21,
  'FRAME_L4-SPONGE-FLAYEREVO4': 22,
  'FRAME_L5-AOE-VOIDVIRUS': 23,
  'FRAME_L5-ARMOR-VOIDTURTLE': 24,
  'FRAME_L5-BALANCED-VOIDSPIDER': 25,
  'FRAME_L5-BOSS-GARBAGECAN': 26,
  'FRAME_L5-DAMAGE-VOIDSNAKE': 27,
  'FRAME_L5-SPONGE-VOIDSQUIRREL': 28,
  'FRAME_L6-BOSS-OCTOPOT': 29,
  'FRAME_NPC-CYCLOPS2': 30
};
spritesheetRegister(module.exports);
